import React, { useEffect, useState } from 'react'
import moment from 'moment'

//antd
import { Form, Drawer, Row, Col, Button, Input, notification, DatePicker, Select } from 'antd'

//apis
import { updateEmployee, addEmployee } from 'apis/staff'
import { getBranches } from 'apis/branch'
import { getRoles } from 'apis/role'

//components
import SearchAddress from 'components/search-address'

export default function EmployeeForm({ children, reloadData, record }) {
  const [form] = Form.useForm()

  const [branchs, setBranchs] = useState([])
  const [roles, setRoles] = useState([])
  const [address, setAddress] = useState([])

  const [loading, setLoading] = useState(false)
  const [visible, setVisible] = useState(false)
  const toggle = () => setVisible(!visible)

  const _addOrEditUser = async () => {
    try {
      await form.validateFields()
      const dataForm = form.getFieldsValue()

      setLoading(true)
      var body = {
        ...dataForm,
        avatar: '',
        first_name: dataForm.first_name || '',
        email: dataForm.email || '',
        phone: dataForm.phone || '',
        birthday: dataForm.birthday || '',
        // address: JSON.parse(address?.value).description || '',
        district: dataForm.district || '',
        province: dataForm.province || '',
        branch_id: dataForm.branch_id,
        password: dataForm.password
      }
      if (address && address.value) body.address = JSON.parse(address.value).description

      let res
      if (record) res = await updateEmployee(record.user_id, body)
      else res = await addEmployee(body)
      if (res.status === 200) {
        if (res.data.success) {
          toggle()
          reloadData()
          notification.success({
            message: `${record ? 'Cập nhật' : 'Thêm'} nhân viên thành công`,
          })
        } else
          notification.error({
            message:
              res.data.message ||
              `${record ? 'Cập nhật' : 'Thêm'} nhân viên thất bại, vui lòng thử lại`,
          })
      } else
        notification.error({
          message:
            res.data.message ||
            `${record ? 'Cập nhật' : 'Thêm'} nhân viên thất bại, vui lòng thử lại`,
        })
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const _getRoles = async () => {
    try {
      const res = await getRoles()
      if (res.status === 200) setRoles(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  const _getBranches = async () => {
    try {
      const res = await getBranches()
      if (res.status === 200) setBranchs(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    _getBranches()
    _getRoles()
  }, [])

  useEffect(() => {
    if (visible) {
      if (!record) {
        form.resetFields()
      } else {
        form.setFieldsValue({
          ...record,
          birthday: record.birthday ? moment(record.birthday) : null,
          branch_id: record.branch_id,
        })
      }
    }
  }, [visible])

  return (
    <>
      <div onClick={toggle}>{children}</div>
      <Drawer
        width="70%"
        footer={
          <Row justify="end">
            <Button
              onClick={_addOrEditUser}
              loading={loading}
              size="large"
              type="primary"
              style={{ width: 120 }}
            >
              {record ? 'Cập nhật' : 'Thêm'}
            </Button>
          </Row>
        }
        title={`${record ? 'Cập nhật' : 'Thêm'} nhân viên`}
        placement="right"
        onClose={toggle}
        visible={visible}
      >
        <Form layout="vertical" form={form}>
          <Row justify="space-between" align="middle">
            <Col xs={24} sm={24} md={11} lg={11} xl={11}>
              <Form.Item label="Họ" name="first_name">
                <Input placeholder="Nhập họ" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={11} lg={11} xl={11}>
              <Form.Item
                label="Tên"
                name="last_name"
                rules={[{ required: true, message: 'Vui lòng nhập tên!' }]}
              >
                <Input placeholder="Nhập tên" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={11} lg={11} xl={11} style={{ display: record && 'none' }}>
              <Form.Item
                label="Tài khoản"
                name="username"
                rules={[
                  {
                    required: record ? false : true,
                    message: 'Vui lòng nhập email/ số điện thoại!',
                  },
                ]}
              >
                <Input placeholder="Nhập email/ số điện thoại" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={11} lg={11} xl={11} style={{ display: record && 'none' }}>
              <Form.Item
                label="Mật khẩu"
                name="password"
                rules={[{ required: record ? false : true, message: 'Vui lòng nhập mật khẩu!' }]}
              >
                <Input.Password placeholder="Nhập mật khẩu" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={11} lg={11} xl={11}>
              <Form.Item
                label="Chọn nhà hàng làm việc"
                name="branch_id"
                rules={[{ message: 'Vui lòng chọn nhà hàng làm việc!', required: true }]}
              >
                <Select placeholder="Chọn nhà hàng làm việc" mode="multiple">
                  {branchs.map((branch, index) => (
                    <Select.Option value={branch.branch_id} key={branch.branch_id}>
                      {branch.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={11} lg={11} xl={11}>
              <Form.Item label="Email" name="email">
                <Input placeholder="Nhập email" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={11} lg={11} xl={11}>
              <Form.Item label="Số điện thoại" name="phone">
                <Input placeholder="Nhập liên hệ" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={11} lg={11} xl={11}>
              <Form.Item label="Ngày sinh" name="birthday">
                <DatePicker placeholder="Chọn ngày sinh" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={11} lg={11} xl={11}>
              <Form.Item label="Địa chỉ" name="address">
                <SearchAddress setAddress={setAddress} placeholder="Nhập địa chỉ" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={11} lg={11} xl={11}>
              <Form.Item
                label="Vai trò"
                name="role_id"
                rules={[{ message: 'Vui lòng chọn vai trò!', required: true }]}
              >
                <Select placeholder="Chọn vai trò">
                  {roles.map((role, index) => (
                    <Select.Option value={role.role_id} key={index}>
                      {role.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </>
  )
}
